import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs'; 
import { StaticData } from '../../../helpers/static-data'; 

@Component({
  selector: 'app-footer-pqrs',
  templateUrl: './footer-pqrs.component.html',
  styleUrls: ['./footer-pqrs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterPqrsComponent implements OnInit, OnDestroy {
  mostrarFooter = false;
  safeHtml: SafeHtml;
  private configSub: Subscription;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.cargarHtml();

    this.configSub = StaticData.onConfigUpdated.subscribe(() => {
      this.cargarHtml();
    });
  }

  ngOnDestroy() {
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }

  private cargarHtml() {
    // Validación clásica compatible con Angular 8
    let htmlFooter = null;
    if (StaticData.GeneralConfig && StaticData.GeneralConfig.ConfigUI) {
      htmlFooter = StaticData.GeneralConfig.ConfigUI.FooterPortalRadicacion;
    }
    
    if (htmlFooter && htmlFooter.trim() !== '') {
      this.mostrarFooter = true;
      this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(htmlFooter);
      console.warn('¡Footer HTML cargado exitosamente!');
    } else {
      this.mostrarFooter = false;
    }
  }
}